import AnnualReportForm from "../../../model/AnnualReportForm";
import {useState} from "react";

const WERE_THERE_LEGAL_CHANGES_TO_INSTITUTE = `Have there been any legal or structural changes to your institution, or has your affiliation with the institution changed in the past 12 months?`;
const EXPLAIN_CHANGES = `Please explain these changes.`;

/**
 * Props for this component
 */
interface LegalChangesToInstitutionQuestionProps {
   form: AnnualReportForm,
   isLocked: boolean,
}

/**
 * Question regarding legal changes to the institute in the previous 12 months
 *
 * Used in: {@link ApplicantAnnualReportForm|Applicant annual report}
 * @param form An {@link AnnualReportForm} object with a saved report (Could be empty if it's a new report)
 * @param isLocked A boolean to indicate if the report is locked for editing or not
 */
export default function LegalChangesToInstitutionQuestion({form, isLocked}: LegalChangesToInstitutionQuestionProps) {
   // State to control the showing/hiding of the text area
   const [inputBoxShowing, setInputBoxShowing] = useState(form.hasLegalOrInstitutionalChange);

   return (
      <div id="institueLegalChangesQ" className="annual-report-question">
         <label id="institueLegalChangesQMainText"
                className="question-text">{WERE_THERE_LEGAL_CHANGES_TO_INSTITUTE}</label>
         {isLocked ? (
            <span className="boolean-answer">{form.hasLegalOrInstitutionalChange ? 'YES' : 'NO'}</span>
         ) : (
            //Radio Button Area
            <div id="institueLegalChangesQRadioArea" className="yes-or-no-radio">
               <input id="institueLegalChangesQRadioYesInput" className="form-check-input" type="radio"
                      name="institueLegalChangesQRadioSelection"
                      data-bs-toggle={!inputBoxShowing ? "collapse" : ""}
                      data-bs-target="#institueLegalChangesQTextInput"
                      aria-expanded="false"
                      aria-controls="institueLegalChangesQTextInput"
                      required
                      onChange={() => {
                         form.hasLegalOrInstitutionalChange = true;
                         setTimeout(() => {
                            setInputBoxShowing(true);
                         }, 10);
                      }}
                      defaultChecked={(form.annualReportId && form.hasLegalOrInstitutionalChange != null) ? (form.hasLegalOrInstitutionalChange) : false}
               />
               <label id="institueLegalChangesQRadioYesText" className="form-check-label"
                      htmlFor="institueLegalChangesQRadioYesInput">
                  Yes
               </label>
               <input id="institueLegalChangesQRadioNoInput" className="form-check-input" type="radio"
                      name="institueLegalChangesQRadioSelection"
                      data-bs-toggle={inputBoxShowing ? "collapse" : ""}
                      data-bs-target="#institueLegalChangesQTextInput"
                      aria-expanded="false"
                      aria-controls="institueLegalChangesQTextInput"
                      required
                      onChange={() => {
                         form.hasLegalOrInstitutionalChange = false;

                         setTimeout(() => {
                            setInputBoxShowing(false);
                         }, 300);
                      }}
                      defaultChecked={(form.annualReportId && form.hasLegalOrInstitutionalChange != null) ? (!form.hasLegalOrInstitutionalChange) : false}
               />
               <label id="institueLegalChangesQRadioNoText" className="form-check-label"
                      htmlFor="institueLegalChangesQRadioNoInput">
                  No
               </label>
               <div id="institueLegalChangesQRadioAreaFeedback" className="invalid-feedback">
                  Please select one option.
               </div>
            </div>
         )}
         {/*Text input area*/}
         <div className="accordion accordion-flush" id="institueLegalChangesQAccordion">
            <div id="institueLegalChangesQTextInput"
                 className={`annual-report-question accordion-collapse collapse ${form.hasLegalOrInstitutionalChange ? "show" : ""}`}
                 data-bs-parent="#institueLegalChangesQAccordion">
               <span id="institueLegalChangesQResourceText" className="question-text">
                  {EXPLAIN_CHANGES}
               </span>
               <textarea id="institueLegalChangesQReasoningInput" name="lastYearResInput" className="form-control"
                         rows={3}
                         disabled={isLocked}
                         onChange={(e) => form.legalOrInstitutionalChangeExplanation = encodeURIComponent(e.target.value)}
                         required={inputBoxShowing != null && inputBoxShowing} minLength={100} maxLength={1000}>
         {decodeURIComponent(form.legalOrInstitutionalChangeExplanation ? form.legalOrInstitutionalChangeExplanation : '')}</textarea>
               <div id="lastYearResScopeFeedback" className="invalid-feedback">
                  Your answer must have between 100 and 1000 characters.
               </div>
            </div>
         </div>
      </div>
   );
}
